<template>
    <div class="card let-space-1 h-100">
        <div class="card-header px-2 pb-1">
            <div class="d-flex">
                <div class="form-group form-check mb-0">
                    <input v-if="item.email_flg == '0'" type="checkbox" class="form-check-input" :disabled="!canMailFlg" @click="changeMailFlg" checked>
                    <input v-else type="checkbox" class="form-check-input" :disabled="!canMailFlg" @click="changeMailFlg">
                    <small>
                        <span v-if="item.user_group != 'none'">
                            {{item.user_group_nm}}
                            &nbsp;/&nbsp;({{item.user_group}})
                        </span>
                        <span v-else>
                            システム会員
                        </span>
                        <span v-if="!(item.summary_title && item.summary_sys)">
                            <i class="fas fa-exclamation text-danger-cust"></i>
                        </span>
                        <span v-if="!(item.resume || item.resume_pdf)">
                            <i class="far fa-file-excel text-danger-cust"></i>
                        </span>
                        <span v-if="item.input_group == 'none' && item.user_group != 'none'"> 
                            <span>個人営業</span>
                            <span v-if="item.sales_nm" class="text-nowrap">/{{item.sales_nm}}</span>
                            <span v-else class="text-nowrap">/氏名無し</span>
                            <span class="text-nowrap">/{{item.email}}</span>
                        </span>
                    </small>
                </div>
                <div class="text-right flex-fill">
                    <span class="text-muted pl-2 ml-auto" @click="openMenu">
                        <i class="fas fa-ellipsis-v"></i>
                    </span>
                </div>
            </div>
            <div class="d-flex">
                <div>
                    <span v-show="item.recent_in_day">
                        <small>
                            In:{{item.recent_in_day | dformatw }}
                        </small>
                    </span>
                </div>
                <div v-show="item.recent_out_day" class="text-right flex-fill" :class="{'text-success': sendOver}">
                    <small>
                        Out:{{item.recent_out_day | dformatw}}
                    </small>
                </div>
            </div>
        </div>
        <div class="card-body p-2" @click="toDetail">
            <div><small>te.{{item.id}}</small></div>
            <div>
                <span>
                    {{item.name}} ({{item.gender == '0'?'男性':'女性'}} {{item.age+'歳'}})
                </span>
                <span v-if="item.hope_price_start == item.hope_price_end">&nbsp;{{ item.hope_price_end }}万</span>
                <span v-else>&nbsp;{{ item.hope_price_start }} ~ {{ item.hope_price_end }}万</span>
                <span v-if="item.work_start_date">&nbsp;{{editStartDate(item.work_start_date)}}</span>
            </div>
            <div>
                <small>
                    <span v-if="item.relation_cmp" class="text-nowrap border rounded px-1">{{converVal('relation_cmp', item.relation_cmp)}}</span>
                    <span v-if="item.nearest_station" class="text-nowrap border rounded px-1">{{item.nearest_station}}</span>
                    <span v-if="item.country" class="text-nowrap border rounded px-1">{{item.country}}</span>
                    <span v-if="item.exper" class="text-nowrap border rounded px-1">exp{{item.exper}}</span>
                </small>
            </div>
            <div class="pt-2">
                <span class="pr-2">
                    <small>
                        <i class="fas fa-pen"></i>
                        {{item.user_nm}}
                    </small>
                </span>
            </div>
            <div class="d-flex">
                <div>
                    <span>
                        <small>
                            <i class="fas fa-calendar"></i>
                            {{item.created_at | dformatm }}
                        </small>
                    </span>
                </div>
                <div class="text-right flex-fill" :class="{'text-success': sendOver}">
                    <small>
                        <i class="fas fa-sync"></i>
                        {{item.updated_at | dformatm}}
                    </small>
                </div>
            </div>
        </div>
        <div class="card-footer p-2">
            <span v-if="item.contract_id"> 契約ID：{{item.contract_id}} </span>
            <span v-else> 契約なし </span>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'
    import {converVal} from 'pages/commons/form/selectList'
    import {isOverContractEnd
            ,editProjStartDate
            ,dateCompare} from 'pages/commons/form/comFunc'

    export default {
        props: {
            item: Object
        },
        data () {
            return {
                selectedTech: "",
            }
        },
        computed: {
            canMailFlg () {
                return this.item.summary_title && this.item.summary_sys && (this.item.resume || this.item.resume_pdf) ? true : false
            },
            sendOver () {
                return this.dateCompare()
            }

        },
        methods: {
            toDetail () {
                this.saveSelectedTechLocal(this.item.id)

                this.$router.push({name: 'TechResumeCreate', params:{
                    do: 'show',
                    id: this.item.id
                }})
            },
            openMenu () {
                EventBus.$emit('busOnTechResumeMenu', this.item)
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            editStartDate (val) {
                return editProjStartDate(val)
            },
            saveSelectedTechLocal (id) {
                try {
                    localStorage.setItem('selectedTech', JSON.stringify(id))
                } catch (e) { }
            },
            changeMailFlg () {
                this.$store.dispatch('changeTechResumeMailFlg', {
                    id: this.item.id,
                    emailFlg: this.item.email_flg == '0' ? '1': '0'
                })
            },
            dateCompare () {
                return dateCompare(new Date, '=',  this.item.recent_out_day, 'day')
            }
        }
    }

</script>

<style lang="stylus" scoped>
    .selected-tech
        background-color: #4dc0b521
</style>
